import { useSelector } from "react-redux";
import { getUserSelectedAccountCode } from "../app/appSelectors.js";

function useAccountStorage() {
    const selectedAccountCode = useSelector(getUserSelectedAccountCode);

    const setAccountStorageItem = (name, value) => {
        try {
            const params = JSON.parse(localStorage.getItem(selectedAccountCode) || '{}');
            params[name] = value;
            localStorage.setItem(selectedAccountCode, JSON.stringify(params));
        } catch (e) {
            localStorage.setItem(selectedAccountCode, JSON.stringify({
                [name]: value,
            }));
        }
    }

    const getAccountStorageItem = (name, def = undefined) => {
        try {
            const params = JSON.parse(localStorage.getItem(selectedAccountCode) || '{}');
            return params[name] || def;
        } catch (e) {
            return def;
        }
    }

    return {
        setAccountStorageItem,
        getAccountStorageItem,
    };
}

export default useAccountStorage;
